/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FoundHsCodeDTO { 
    id?: number;
    code?: string;
    description?: string;
    type?: FoundHsCodeDTO.TypeEnum;
    isBlocked?: boolean;
    isDeleted?: boolean;
}
export namespace FoundHsCodeDTO {
    export type TypeEnum = 0 | 1 | 2;
    export const TypeEnum = {
        NUMBER_0: 0 as TypeEnum,
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum
    };
}